export default {
  name: 'lx-share-this-socials',
  props: {
    facebook: String,
    x: String,
    telegram: String,
    linkedin: String,
    onClick: Function,
  },
}
